import React, { Component } from "react";
import store from "@/redux/store";

import * as CustomerConst from "actions/customerConst";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

interface BankProps {
    register: any;
    registerkey: string;
    data: any;
    state: any;
    [key: string]: any; //Accept any property
}

export function Bank({ ...props }: BankProps) {   




let index = 0;
let registerKey = props.registerkey;
  return (
    <>
          <div className="">
            <div className="space-y-8 pb-12 sm:space-y-0   sm:pb-0">


                <div className="grid grid-cols-12 gap-3">


            <FieldHolder colspan="12" smcolspan="8" label="Rekening nummer" id={registerKey+`bank_account_no`} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    {...props.register(registerKey+'bank_account_no')}
                    key={(props.data && props.data.bank_account_no) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>

              </div>
            </div>
          </div>
        
    </>
      );
}      

